import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PercentageCircleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.3 9.3H9.309M14.7 14.7H14.709M15.6 8.4L8.4 15.6M21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12ZM9.75 9.3C9.75 9.549 9.549 9.75 9.3 9.75C9.051 9.75 8.85 9.549 8.85 9.3C8.85 9.051 9.051 8.85 9.3 8.85C9.549 8.85 9.75 9.051 9.75 9.3ZM15.15 14.7C15.15 14.948 14.948 15.15 14.7 15.15C14.452 15.15 14.25 14.948 14.25 14.7C14.25 14.452 14.452 14.25 14.7 14.25C14.948 14.25 15.15 14.452 15.15 14.7Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

PercentageCircleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PercentageCircleIcon);
